export const AnalyticsEventCategory = {
  ASSIGNMENT: 'assignment',
  EXPLORE: 'explore',
  HOME: 'home-v2',
  PHASE: 'phase',
  PHASE_TYPE: 'phase-type',
  PLAYER_REPORT: 'player-report',
  PRESET: 'preset',
  REPORT: 'report',
  ROSTER: 'roster',
  SESSION: 'session',
  SESSION_REPORT: 'session-report',
  WEEKLY_REPORT: 'weekly-report',
  WHATS_NEW: 'whats-new',
  WIDGET_PERFORMANCE_HISTORY: 'widget-performance-history',
  WIDGET_SHOT_AREA_MAP: 'widget-shot-area-map',
  WIDGET_SHOT_HISTORY: 'widget-shot-history',
  WIDGET_SHOT_LOAD_MAP: 'widget-shot-load-map',
  WIDGET_RANKING: 'widget-ranking',
  WIDGET_TIME_RANE_SUMMARY: 'widget-time-range-summary',
} as const;
